import { AbstractEntity } from "../AbstractEntity";
export default class Charterer extends AbstractEntity {
    address;
    name;
    constructor(address, name) {
        super();
        this.address = address;
        this.name = name;
    }
}
//# sourceMappingURL=Charterer.js.map